import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import * as actions from './checkin-passenger-input.actions';
import { CheckinPassengerInputState } from './checkin-passenger-input.state';

/**
 * checkinPassengerInput initial state
 */
export const checkinPassengerInputInitialState: CheckinPassengerInputState = {
  model: null,
};

/**
 * List of basic actions for CheckinPassengerInput Store
 */
export const checkinPassengerInputReducerFeatures: ReducerTypes<CheckinPassengerInputState, ActionCreator[]>[] = [
  on(actions.setCheckinPassengerInput, (_state, payload) => ({ ...payload })),

  on(actions.updateCheckinPassengerInput, (state, payload) => ({ model: { ...state.model, ...payload.model } })),

  on(actions.resetCheckinPassengerInput, () => checkinPassengerInputInitialState),
];

/**
 * CheckinPassengerInput Store reducer
 */
export const checkinPassengerInputReducer = createReducer(
  checkinPassengerInputInitialState,
  ...checkinPassengerInputReducerFeatures
);
